var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3DotsVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 24,
    viewBox: "0 0 6 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26128 23.0254C1.76002 23.0254 0.539063 21.8084 0.539063 20.3071C0.539063 18.8058 1.76002 17.5888 3.26128 17.5888C4.76255 17.5888 5.98351 18.8058 5.98351 20.3071C5.98351 21.8084 4.76255 23.0254 3.26128 23.0254Z",
    fill: "#343633"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.539062,
    y: 14.4824,
    width: 5.43657,
    height: 5.44444,
    rx: 2.71828,
    transform: "rotate(-90 0.539062 14.4824)",
    fill: "#343633"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.539062,
    y: 5.93945,
    width: 5.43657,
    height: 5.44444,
    rx: 2.71828,
    transform: "rotate(-90 0.539062 5.93945)",
    fill: "#343633"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3DotsVertical);
export default __webpack_public_path__ + "static/media/icon_3_dots_vertical.ca901095daac386ef24e6ad27636c281.svg";
export { ForwardRef as ReactComponent };